import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { groupDigits, parseNumber } from "@/lib/format";

const displayFor = (value, kind) =>
  value === null || value === undefined || value === ""
    ? ""
    : groupDigits(String(kind === "percent" ? value : Math.round(Number(value) * 100) / 100));

/** Thousands-separated numeric input that stores a raw number. */
export const RateInput = ({ value, onChange, kind = "money", testId, ariaLabel, invalid }) => {
  const [text, setText] = useState(() => displayFor(value, kind));

  // Resync only when the saved rate and the text on screen disagree - that is
  // what lets a reset or a restored version show through without wiping what
  // somebody is part-way through typing.
  useEffect(() => {
    const parsed = parseNumber(text);
    if (parsed !== Number(value)) setText(displayFor(value, kind));
  }, [value, text, kind]);

  const prefix = kind === "money" ? "R" : null;
  const suffix = kind === "percent" ? "%" : null;

  const handleChange = (event) => {
    // A fee can never be negative, so a minus sign is dropped as it is typed.
    // The backend ignores negatives too (rate_card._to_number), but stopping it
    // here means the admin sees straight away that it won't be accepted.
    const raw = event.target.value.replace(/-/g, "");
    const next = kind === "percent" ? raw : groupDigits(raw);
    setText(next);
    onChange(parseNumber(next));
  };

  return (
    <div className="relative">
      {prefix ? (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-muted-foreground"
        >
          {prefix}
        </span>
      ) : null}
      <Input
        data-testid={testId}
        aria-label={ariaLabel}
        aria-invalid={invalid ? "true" : "false"}
        inputMode="decimal"
        value={text}
        onChange={handleChange}
        className={`h-10 font-amount tabular-nums ${prefix ? "pl-7" : ""} ${
          suffix ? "pr-7" : ""
        } ${invalid ? "border-destructive" : ""}`}
      />
      {suffix ? (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm font-semibold text-muted-foreground"
        >
          {suffix}
        </span>
      ) : null}
    </div>
  );
};
